export default __webpack_public_path__ + "static/media/image3.64d73b98.png";